// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2-UqN","log":"ModalInventoryLogs_log__1nBY5","date":"ModalInventoryLogs_date__35qrp","userName":"ModalInventoryLogs_userName__10sQS"};